export default __webpack_public_path__ + "static/media/5.c3c5dec5.jpg";